import React from "react";
import { injectIntl } from "react-intl";
import { useHistory } from "react-router-dom";
import { inject, observer } from "mobx-react";
import {
  Root,
  LinkButton,
} from "@/common/Styled/CommonStyled";
import { ContentsBox, ListBox } from "./Styled/SettingStyled";
import TitleBox from "../CommonComponent/TitleBox";
import { callBrowser } from "../../nativebridge/JsToNative";
import { Icon } from '@iconify/react';
import {COMMON_UTIL} from "@/common/util/common.util";

function TermsOfUse(props) {
  const { intl, languageStore } = props;
  const history = useHistory();

  const domain = window.location.protocol + '//' + window.location.host;
  const termsUrls = {
    privacyPolicy:  `${domain}/policy/privacy/${languageStore.language === 'ko' ? 'ko' : 'en'}`,
    termsOfService: `${domain}/policy/service/${languageStore.language === 'ko' ? 'ko' : 'en'}`,
    endUserLicenseAgreement: `${domain}/policy/eula/${languageStore.language === 'ko' ? 'ko' : 'en'}`,
  };

  const handleBack = () => {
    history.goBack();
  };

  const handleClick = (url) => {
    if (COMMON_UTIL.isWebView()){
      callBrowser(url);
    }else{
      window.open(url);
      setTimeout(() => {
        // 여기에 클릭 가능한 상태 업데이트 로직을 추가
      }, 100); // 100ms 후에 상태 업데이트
    }
  };

  return (
    <Root>
      <TitleBox
        title={intl.formatMessage({ id: "terms_of_service" })} /* 이용약관 */
        subtitle={intl.formatMessage({ id: "terms_description" })} /* 서비스 이용과 관련하여 필요한 사항을 규정합니다. */
        onBack={handleBack}
      />

      <ContentsBox className="setting-box">
        <ListBox>
          <LinkButton
            to={"/"}
            onClick={(e) => {
              e.preventDefault();
              handleClick(termsUrls.privacyPolicy);
            }}
          >
            {intl.formatMessage({ id: "privacy_policy" })}{/* 개인정보 보호정책 */}
            <Icon icon="weui:arrow-outlined" fontSize={20}/>
          </LinkButton>
          <LinkButton
            to={"/"}
            onClick={(e) => {
              e.preventDefault();
              handleClick(termsUrls.termsOfService);
            }}
          >
            {intl.formatMessage({ id: "service_terms" })}{/* 서비스 이용약관 */}
            <Icon icon="weui:arrow-outlined" fontSize={20}/>
          </LinkButton>
          <LinkButton
            to={"/"}
            onClick={(e) => {
              e.preventDefault();
              handleClick(termsUrls.endUserLicenseAgreement);
            }}
          >
            {intl.formatMessage({ id: "end_user_license_agreement" })}{/* 최종사용자 사용권 계약 */}
            <Icon icon="weui:arrow-outlined" fontSize={20}/>
          </LinkButton>
        </ListBox>
      </ContentsBox>
    </Root>
  );
}

export default injectIntl(inject("languageStore")(observer(TermsOfUse)));
